export default cnpj => {

    cnpj = cnpj.toUpperCase().replace(/[./-]/g, '');

    if (/[^A-Z\d]/.test(cnpj)) {
        return false;
    }

    if (!/^([A-Z\d]){12}(\d){2}$/.test(cnpj)) {
        return false;
    }

    if (cnpj === '00000000000000') {
        return false;
    }

    const pesos = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

    let somatorioDV1 = 0;
    let somatorioDV2 = 0;

    for (let i = 0; i < 12; i++) {
        // Valor ASCII do caractere - ASCII de '0'
        const valor = cnpj.charCodeAt(i) - '0'.charCodeAt(0);

        somatorioDV1 += valor * pesos[i + 1];
        somatorioDV2 += valor * pesos[i];
    }

    const dv1 = (somatorioDV1 % 11) < 2 ? 0 : 11 - (somatorioDV1 % 11);

    somatorioDV2 += dv1 * pesos[12];

    const dv2 = (somatorioDV2 % 11) < 2 ? 0 : 11 - (somatorioDV2 % 11);

    return cnpj.substring(12, 14) === `${dv1}${dv2}`;
}